import { render, staticRenderFns } from "./PaginaEspacoDoColaborador.vue?vue&type=template&id=6d4068b0&scoped=true"
import script from "./PaginaEspacoDoColaborador.vue?vue&type=script&lang=js"
export * from "./PaginaEspacoDoColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4068b0",
  null
  
)

export default component.exports